<lcs-loading-overlay
  class="flex-dir-col"
  [show]="callState | lcsCallState : 'loading'"
  *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Phone Number'"
  >
  <div class="detail-page-headerbar">
    <div class="left">
      <div class="page-heading">
        @if (phoneNumber?.phoneNumber && idsFromRegister?.length > 0) {
          <div class="nav-buttons">
            <button [disabled]="!hasNavigateUp" mat-icon-button (click)="onNavigateUp()">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <span class="detail-index">{{ indexDisplay }}</span>
            <button [disabled]="!hasNavigateDown" mat-icon-button (click)="onNavigateDown()">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>
        }
        <h2 class="page-title"
          >{{ phoneNumber?.phoneNumber | formatPhoneNumbers
          }}@if (phoneNumber?.displayName) {
          <span> - {{ phoneNumber.displayName }}</span>
          }</h2
          >
        </div>
      </div>
      <div class="right context-actions">
        <button
          type="button"
          mat-button
          [matMenuTriggerFor]="updateDetailsMenu"
          matTooltip="Info"
          aria-label="Phone Number Info"
          id="phone-number-detail-info"
          >
          <mat-icon>info</mat-icon>
        </button>
        @if (isSystemUser && (canRelease() || canDelete())) {
          <button
            type="button"
            mat-button
            [matMenuTriggerFor]="phoneNumberRelease"
            aria-label="Phone Number Actions"
            matTooltip="More Actions"
            id="phone-number-detail-more-actions"
            >
            <mat-icon>more_horiz</mat-icon>
          </button>
        }
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
        <div ndtLeftColumn>
          <div class="details-wrapper">
            @if (phoneNumber?.displayName) {
              <h5>Display Name</h5>
              <div class="detail-item">{{ phoneNumber.displayName }}</div>
            }
            @if (phoneNumber?.location && phoneNumber?.account?.accountId) {
              <h5>Location</h5>
              <div class="detail-item location">{{ phoneNumber.location | ndtFullLocation }}</div>
            }
            @if (phoneNumber?.providerId && isSystemUser) {
              <h5>Provider</h5>
              <div class="detail-item">{{ phoneNumber.providerId }}</div>
            }
            @if (phoneNumber?.openExtension && phoneNumber?.account?.accountId) {
              <h5>Open Extension</h5>
              <div class="detail-item"
                ><a [routerLink]="['/extensions', phoneNumber.openExtension.extensionId]"
                >{{ phoneNumber.openExtension.number }} - {{ phoneNumber.openExtension.name }}</a
                ></div
                >
              }
              @if (phoneNumber?.closedExtension && phoneNumber?.account?.accountId) {
                <h5>Closed Extension</h5>
                <div class="detail-item"
                  ><a [routerLink]="['/extensions', phoneNumber.closedExtension.extensionId]"
                  >{{ phoneNumber.closedExtension.number }} - {{ phoneNumber.closedExtension.name }}</a
                  ></div
                  >
                }
                @if (phoneNumber?.schedule && phoneNumber?.account?.accountId) {
                  <h5>Schedule</h5>
                  <div class="detail-item"
                    ><a [routerLink]="['/schedules', phoneNumber.schedule.scheduleId]">{{
                    phoneNumber.schedule.name
                  }}</a></div
                  >
                }
                @if (phoneNumber?.notes) {
                  <h5>Notes</h5>
                  <div class="detail-item">{{ phoneNumber.notes }}</div>
                }
                <ng-container>
                  <h5>e911 Registration</h5>
                  <div class="detail-item">
                    <span>{{ phoneNumber?.isE911Registered ? 'e911 Registered' : 'Not e911 Registered' }}</span>
                  </div>
                </ng-container>
                @if (isSystemUser && phoneNumber?.isPorted) {
                  <h5>Port Information</h5>
                  <div class="detail-item">Ported on {{ phoneNumber?.datePorted | date : 'MM/dd/yyyy hh:mm aa' }}</div>
                }
                <ng-container>
                  <h5>Comments</h5>
                  <div class="detail-item">
                    {{ phoneNumber?.portedComments }}
                  </div>
                </ng-container>
              </div>
            </div>
            <div ndtRightColumn>
              <div class="detail-right-column">
                <ndt-card [title]="'General Information'" class="detail-card-half">
                  @if (isSystemUser) {
                    <mat-form-field class="flex-half">
                      <mat-label>Number</mat-label>
                      <input
                        matInput
                        autocomplete="off"
                        type="tel"
                        [value]="phoneNumber?.phoneNumber"
                        formControlName="phoneNumber"
                        id="phoneNumber"
                        />
                      </mat-form-field>
                    }
                    @if (isSystemUser) {
                      <mat-form-field class="flex-half">
                        <mat-label>Provider</mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          formControlName="providerId"
                          id="providerId"
                          lcsStaticSelect
                          (search)="providerSearch($event)"
                          (reset)="providerReset()"
                          [lcsSingleSelect]="providerSelect"
                          required
                          />
                          @if (form.get('providerId')?.hasError('required')) {
                            <mat-error>Provider is Required. </mat-error>
                          }
                          <lcs-static-select #providerSelect [displayWith]="providerDisplayWith">
                            @for (provider of providers; track provider) {
                              <lcs-option [value]="provider">
                                {{ provider }}
                              </lcs-option>
                            }
                          </lcs-static-select>
                        </mat-form-field>
                      }
                      <mat-form-field class="flex-full">
                        <mat-label>Display Name</mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          [value]="phoneNumber?.displayName"
                          formControlName="displayName"
                          id="displayName"
                          />
                        </mat-form-field>
                        <mat-checkbox
                          class="flex-full"
                          [checked]="phoneNumber?.isActive"
                          formControlName="isActive"
                          id="isActive"
                          >Active
                        </mat-checkbox>
                      </ndt-card>
                      <ndt-card [title]="'Notes'" class="detail-card-half">
                        <mat-form-field class="flex-full">
                          <mat-label>Notes</mat-label>
                          <textarea matInput formControlName="notes" id="notes" [value]="phoneNumber?.notes"></textarea>
                        </mat-form-field>
                      </ndt-card>

                      <ndt-card [title]="'Settings'" class="detail-card">
                        <mat-form-field [hidden]="!phoneNumber?.account?.accountId" class="flex-half">
                          <mat-label>Open Extension</mat-label>
                          <input
                            autocomplete="off"
                            type="text"
                            [lcsSingleSelect]="openExtensionSelect"
                            [accountId]="phoneNumber?.account?.accountId"
                            [required]="form.get('isActive')?.value"
                            ndtExtensionSelect
                            formControlName="openExtension"
                            id="openExtension"
                            [extensionTypesToExclude]="[7]"
                            />
                            <ndt-extension-select #openExtensionSelect isIncludeEmptyOption="true"></ndt-extension-select
                              >@if (form.get('openExtension')?.hasError('required')) {
                              <mat-error>
                                Open Extension is required on active Phone Numbers.
                              </mat-error>
                            }
                          </mat-form-field>
                          <mat-form-field [hidden]="!phoneNumber?.account?.accountId" class="flex-half">
                            <mat-label>Closed Extension</mat-label>
                            <input
                              autocomplete="off"
                              type="text"
                              [lcsSingleSelect]="closedExtensionSelect"
                              [required]="form.get('isActive')?.value"
                              ndtExtensionSelect
                              [accountId]="phoneNumber?.account?.accountId"
                              formControlName="closedExtension"
                              id="closedExtension"
                              [extensionTypesToExclude]="[7]"
                              />
                              <ndt-extension-select #closedExtensionSelect isIncludeEmptyOption="true"></ndt-extension-select
                                >@if (form.get('closedExtension')?.hasError('required')) {
                                <mat-error>
                                  Closed Extension is required on active Phone Numbers.
                                </mat-error>
                              }
                            </mat-form-field>
                            @if (phoneNumber?.account?.accountId) {
                              <mat-form-field class="flex-half">
                                <mat-label>Schedule</mat-label>
                                <input
                                  autocomplete="off"
                                  type="text"
                                  [lcsSingleSelect]="scheduleSelect"
                                  ndtScheduleSelect
                                  [accountId]="phoneNumber?.account?.accountId"
                                  formControlName="schedule"
                                  id="schedule"
                        [placeholder]="
                           'Use Account schedule' +
                           (phoneNumber?.account?.schedule?.name
                              ? ' - (' + phoneNumber.account.schedule.name + ')'
                              : '')
                        "
                                  />
                                  <ndt-schedule-select
                                    #scheduleSelect
                                    isIncludeEmptyOption="true"
                        [overrideEmptyOption]="
                           'Use Account schedule' +
                           (phoneNumber?.account?.schedule?.name
                              ? ' - (' + phoneNumber.account.schedule.name + ')'
                              : '')
                        "
                                  ></ndt-schedule-select>
                                </mat-form-field>
                              }
                              @if (phoneNumber?.account?.accountId) {
                                <mat-form-field class="flex-half">
                                  <mat-label>Location</mat-label>
                                  <input
                                    autocomplete="off"
                                    type="text"
                                    [lcsSingleSelect]="locationSelect"
                                    ndtLocationSelect
                                    [accountId]="phoneNumber?.account?.accountId"
                                    formControlName="location"
                                    id="location"
                                    [required]="phoneNumber?.account?.accountId && form.get('allowOutboundCalls')?.value"
                                    />
                                    <ndt-location-select
                                      #locationSelect
                        [isIncludeEmptyOption]="
                           phoneNumber?.account?.accountId && !form.get('allowOutboundCalls')?.value
                        "
                                    ></ndt-location-select>
                                    @if (form.get('location')?.hasError('required')) {
                                      <mat-error>
                                        Location is required if outbound calling is enabled
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                }
                                @if (phoneNumber?.account?.timeZoneId) {
                                  <mat-form-field class="flex-half">
                                    <mat-label>Time Zone</mat-label>
                                    <input
                                      class="empty-option-placeholder"
                                      [lcsSingleSelect]="timeZoneSelect"
                                      ndtTimeZoneSelect
                                      autocomplete="off"
                                      type="text"
                                      formControlName="timeZone"
                                      id="timeZone"
                        [placeholder]="
                           'Use Location/Account Time Zone - (' +
                           (form.get('location')?.value?.timeZoneId ?? phoneNumber?.account?.timeZoneId) +
                           ')'
                        "
                                      />
                                      <ndt-time-zone-select
                                        #timeZoneSelect
                                        [isIncludeEmptyOption]="true"
                        [overrideEmptyOption]="
                           'Use Location/Account Time Zone - (' +
                           (form.get('location')?.value?.timeZoneId ?? phoneNumber?.account?.timeZoneId) +
                           ')'
                        "
                                      ></ndt-time-zone-select>
                                      @if (form.get('timeZone')?.hasError('required')) {
                                        <mat-error>
                                          Time Zone Field is Required.
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  }
                                  @if (phoneNumber?.account?.accountId) {
                                    <mat-checkbox
                                      class="flex-full"
                                      [checked]="isFax"
                                      id="fax"
                                      formControlName="isFax"
                                      >Fax Phone Number</mat-checkbox
                                      >
                                  }
                                  @if (phoneNumber?.account?.accountId && isFax) {
                                    <mat-form-field class="flex-half">
                                      <mat-label>Fax Extension</mat-label>
                                      <input
                                        autocomplete="off"
                                        type="text"
                                        [lcsSingleSelect]="faxExtensionSelect"
                                        ndtExtensionSelect
                                        [accountId]="phoneNumber?.account?.accountId"
                                        formControlName="faxExtension"
                                        id="faxExtension"
                                        [extensionType]="[7]"
                                        />
                                        <ndt-extension-select #faxExtensionSelect isIncludeEmptyOption="true"></ndt-extension-select>
                                      </mat-form-field>
                                    }
                                    @if (phoneNumber?.account?.accountId && isSystemUser) {
                                      <mat-checkbox
                                        class="flex-full"
                                        [checked]="phoneNumber?.allowOutboundCalls"
                                        formControlName="allowOutboundCalls"
                                        id="allowOutboundCalls"
                                        >Allow Outbound Calls? (Location Required)</mat-checkbox
                                        >
                                    } @else {
                                      @if (form) {
                                        <div class="allowOutboundCalls-row">
                                          <div class="allowOutboundCalls-header">
                                            <span class="allowOutboundCalls-label">Allow Outbound Calls?</span>
                                            <mat-icon
                                              class="tooltip"
                                 [appTooltip]="
                                    'To change the Allow Outbound Calls setting,\nplease contact your LCS representative.'
                                 "
                                              >help</mat-icon
                                              >
                                            </div>
                                            <div class="allowOutboundCalls-value">
                                              {{ form?.get('allowOutboundCalls')?.value ? 'Yes' : 'No' }}
                                            </div>
                                          </div>
                                        }
                                      }
                                      @if (isSystemUser) {
                                        <mat-checkbox
                                          class="flex-full"
                                          [checked]="phoneNumber?.isPorted"
                                          formControlName="isPorted"
                                          id="ported"
                                          >Ported</mat-checkbox
                                          >
                                        }
                                        @if (isSystemUser) {
                                          <mat-form-field class="flex-full">
                                            <mat-label>Date Ported</mat-label>
                                            <input
                                              matInput
                                              autocomplete="off"
                                              lcsDatepicker
                                              formControlName="datePorted"
                                              id="datePorted"
                                              [lcsDatepickerPanel]="datepickerPanel"
                                              />
                                              @if (form.get('datePorted')?.hasError('required')) {
                                                <mat-error
                                                  >Date Ported is Required.
                                                </mat-error>
                                              }
                                              <lcs-datepicker-toggle matSuffix [for]="datepickerPanel"></lcs-datepicker-toggle>
                                              <lcs-datepicker-panel #datepickerPanel></lcs-datepicker-panel>
                                            </mat-form-field>
                                          }
                                          @if (isSystemUser && !phoneNumber?.account?.accountId) {
                                            <mat-form-field class="flex-full">
                                              <mat-label>Account</mat-label>
                                              <input
                                                autocomplete="off"
                                                [lcsSingleSelect]="accountSelect"
                                                ndtAccountSelect
                                                formControlName="account"
                                                id="account"
                                                />
                                                <ndt-account-select #accountSelect isIncludeEmptyOption="true"></ndt-account-select>
                                              </mat-form-field>
                                            }
                                          </ndt-card>
                                        </div>
                                      </div>
                                    </ndt-two-column-layout>
                                    <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
                                  </form>
                                </lcs-loading-overlay>
                                <mat-menu #phoneNumberRelease="matMenu">
                                  @if (canRelease()) {
                                    <button mat-menu-item type="button" (click)="onReleaseAccountClick()" id="phone-number-release">
                                      Release Phone Number
                                    </button>
                                  }
                                  @if (canDelete()) {
                                    <button mat-menu-item type="button" (click)="onDeleteClick()" id="phone-number-delete">
                                      Delete Phone Number
                                    </button>
                                  }
                                </mat-menu>
                                <mat-menu #updateDetailsMenu="matMenu">
                                  <update-details
                                    [createUser]="phoneNumber?.createUser"
                                    [createDate]="phoneNumber?.createDate"
                                    [updateUser]="phoneNumber?.updateUser"
                                    [updateDate]="phoneNumber?.updateDate"
                                  ></update-details>
                                </mat-menu>
